import { Tab, Tabs } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { observable } from "mobx";
import * as React from "react";
import { newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { MemoriaStore } from "../../stores/memoria/MemoriaStore";
import { MemoriaNfe } from "./MemoriaNfe";
import { MemoriaNfce } from "./MemoriaNfce";
import { MemoriaCte } from "./MemoriaCte";
import { MemoriaNfse } from "./MemoriaNfse";
import InfoModal from "../info-modal/InfoModal";
import RelatorioMemoria from "./RelatorioMemoria";

@observer
export class MemoriaCalculo extends React.Component<{}, {}> {

  obs = observable({
  })

  componentDidMount() {
    AppStore.setTitle("Memória de Cálculo");

    MemoriaStore.obs.select_empresa = newEmpresa()
    MemoriaStore.obs.modelo = MemoriaStore.obs.selectedTab
    MemoriaStore.obs.memoria_calculo = []
    MemoriaStore.obs.current_page = 1
    MemoriaStore.obs.memoria_length = 0

  }

  handleChangeTab(tabId: string) {

    MemoriaStore.obs.modelo = tabId
    MemoriaStore.obs.current_page = 1
    MemoriaStore.resetFilters()
    MemoriaStore.resetDeletarItems()
    MemoriaStore.obs.memoria_calculo = []
    MemoriaStore.obs.memoria_length = 0

    MemoriaStore.obs.selectedTab = tabId

  }

  componentWillUnmount(): void {

    MemoriaStore.obs.select_empresa = newEmpresa()
    MemoriaStore.obs.modelo = MemoriaStore.obs.selectedTab
    MemoriaStore.obs.memoria_calculo = []
    MemoriaStore.obs.current_page = 1
    MemoriaStore.obs.memoria_length = 0

    MemoriaStore.resetFilters()
    MemoriaStore.resetDeletarItems()

  }

  render() {

    return (
      <>
        <Tabs
          id="tabsMemoriaCalculo"
          className="tabsCalculos"
          renderActiveTabPanelOnly={true}
          selectedTabId={MemoriaStore.obs.selectedTab}
          onChange={(tabId) => this.handleChangeTab(tabId as string)}
        >
          <Tab id="nfe" title="NF-E" panel={<MemoriaNfe />} />
          <Tab id="nfce" title="NFC-E" panel={<MemoriaNfce />} />
          <Tab id="cte" title="CT-E" panel={<MemoriaCte />} />
          <Tab id="nfse" title="NFS-E" panel={<MemoriaNfse />} />
          <Tab id="relatorio_memoria" title="Relatórios" panel={<RelatorioMemoria />} />
        </Tabs>

        {MemoriaStore.obs.open_ajuda && <InfoModal open={MemoriaStore.obs.open_ajuda} onClose={() => MemoriaStore.obs.open_ajuda = false} texto_info={`

          <b>Memória CNPJ:</b><br /><br />

          <b>Ativada</b> – O sistema valida o CNPJ de origem nas entradas e o CNPJ de destino nas saídas para salvar a Memória de Cálculo.<br /><br />

          <b>Desativada</b> – O sistema não realiza a validação de CNPJ, permitindo salvar a Memória de Cálculo sem informações de CNPJ.<br /><br />

        `} />}

      </>

    );

  }

}

export default MemoriaCalculo;
